import React, { useContext, useEffect } from 'react'
import './index.scss'
import MaintenanceMobileSubLinks from '@Components/Navigations/MaintenanceMobileSubLinks'
import { observer } from 'mobx-react'
import Navigation from '@App/navigation'
import Button from '@Components/Buttons/Button'
import { StoresContext } from '@App/contexts'
import RightsholderContactTable from '@Components/RightsholderContact/RightsholderContactTable'
import { PERMISSIONS } from '@Const/permissions'
import { RightsholderContact } from '@Entities/rightsholder/rightsholder-contact'
import { ICONS } from '@Const/common'
import ContentHeader from '@Components/ContentHeader'
import PermissionCheck from '@Components/Utility/PermissionCheck'
import RightsholderContactListContentHeader from '@Scenes/RightsholderScene/RightsholderContactList/RightsholderContactListContentHeader'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'

const RightsholderContactList = () => {
    const { uiStore, contactStore, preloaderStore, rightsholderStore } = useContext(StoresContext)

    const getData = async () => {
        preloaderStore.openTransparentPreloader(true)
        const currentRightsHolderId = rightsholderStore.currentRightsholderId
        const contactList = contactStore.rightsholderContacts
        if (contactList?.data && contactList?.count > 0) {
            const isAllContactsForCurrentRightsholder = contactList.data.every(
                (contact: RightsholderContact) => contact.ipId === currentRightsHolderId
            )
            if (!isAllContactsForCurrentRightsholder) {
                await contactStore.loadRightsholderContacts()
            }
        } else {
            await contactStore.loadRightsholderContacts()
        }
        preloaderStore.openTransparentPreloader(false)
    }

    const isMobile = uiStore.isMobile

    useEffect(() => {
        analyticsSendPage('rightsholder_contact_list')
        getData().then()
    }, [])

    const rightsholderContacts = contactStore.rightsholderContacts
    if (!rightsholderContacts) {
        return null
    }

    const blueBoxTitle = 'Contact' + (rightsholderContacts.count !== 1 ? 's' : '')

    return (
        <>
            <title>Contacts</title>
            <div className="rightsholder-contact-list-wrapper">
                <div className="head-block">
                    <ContentHeader title="Contacts" descriptionElement={<RightsholderContactListContentHeader />}>
                        <PermissionCheck
                            requiredPermissions={[PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address]}
                            orIsInternal
                        >
                            <Button
                                mainColor
                                type="primary"
                                className="add-contact-button"
                                typeLink
                                icon={ICONS.add}
                                linkTo={Navigation.rightholder.maintenance.contactInformation(
                                    rightsholderStore.currentRightsholderId,
                                    'new'
                                )}
                            >
                                Add Contact
                            </Button>
                        </PermissionCheck>
                    </ContentHeader>
                </div>
                {isMobile && <MaintenanceMobileSubLinks />}
                <div className="blue-box-line-header">
                    <h5>
                        {rightsholderContacts.count} {blueBoxTitle}
                    </h5>
                </div>
                <section className="items-container">
                    {rightsholderContacts.count > 0 ? (
                        <RightsholderContactTable rightsholderContacts={rightsholderContacts.data} />
                    ) : (
                        <p className="small no-results">You currently have no contacts</p>
                    )}
                </section>
            </div>
        </>
    )
}

export default observer(RightsholderContactList)
